import { ReferenceDataWithSubsetDto } from '../../generated/auth/models/Sasfin/Dynamics/Api/Client/Models/DTO/reference-data-with-subset-dto';

export interface IPortfolioManagersState {
  list: ReferenceDataWithSubsetDto[];
  isLoading: boolean;
}

export const initialUIState = {
  isLoading: false,
};
